import { CODE_TYPE_CUST_LOCATION, CODE_TYPE_URL } from '../../constants';
import { INIT_ROOT, UPDATE_POSTAL_CODE } from '../actionTypes';

export default function isDefaultPostalCode(state, action) {
  const calculateIfDefault = () => {
    if (action.payload.params.country === 'CA') {
      return action.payload.isDefaultPostalCode;
    }
    if (action.payload.params.country === 'US') {
      return (
        action.payload.params.codeType !== CODE_TYPE_CUST_LOCATION &&
        action.payload.params.codeType !== CODE_TYPE_URL
      );
    }
    return false;
  };

  switch (action.type) {
    case INIT_ROOT:
      return calculateIfDefault();
    case UPDATE_POSTAL_CODE:
      return false;
    default:
      return state || false;
  }
}
